import PublicHeader from 'components/layout/Header/PublicHeader';
import styles from './DeviceWhitelistingPublicPage.module.scss';
import PublicPageFooter from 'components/ui/PublicPageFooter/PublicPageFooter';
import AmnisButton from 'components/ui/AmnisButton/AmnisButton';
import useDeviceWhitelistingPublicPage from 'components/pages/DeviceWhitelistingPublicPage/useDeviceWhitelistingPublicPage';
import AmnisLoader from 'components/ui/AmnisLoader/AmnisLoader';
import {AmnisDate} from 'components/ui/AmnisDatePicker/AmnisDate';

const DeviceWhitelistingPublicPage = () => {
    const {
        data,
        isLoading,
        error,
        handleEnableDevice,
        isPending,
        handleDeny,
        selectedLanguageParams,
        handleError,
    } = useDeviceWhitelistingPublicPage();

    if (error) {
        handleError();
        return null;
    }

    return (
        <div className={styles.container}>
            <PublicHeader />
            <div className={styles.card}>
                <div className={styles.header}>
                    <div className={styles.icon}>
                        <Icon />
                    </div>
                    <h5>You have logged in on a new device</h5>
                </div>
                {isLoading ? (
                    <AmnisLoader />
                ) : (
                    <>
                        <div className={styles.content}>
                            <p className={styles.title}>
                                Your amnis account was recently logged into on
                                an unknown device. Find the details below:
                            </p>
                            <div className={styles.details}>
                                <div>
                                    <p className={styles.label}>When</p>
                                    <p data-notranslate>
                                        {AmnisDate.formatApiDateToDisplayDate(
                                            data?.createdAt,
                                            `${selectedLanguageParams.longFormat}, HH:mm`,
                                            selectedLanguageParams.locale,
                                        )}
                                    </p>
                                </div>
                                <div>
                                    <p className={styles.label}>Where</p>

                                    <p data-notranslate>{data?.location}</p>
                                </div>
                                <div>
                                    <p className={styles.label}>Device</p>
                                    <p data-notranslate>{data?.userAgent}</p>
                                </div>
                                <div>
                                    <p className={styles.label}>IP</p>
                                    <p data-notranslate>{data?.ip}</p>
                                </div>
                            </div>
                            <div className={styles.divider} />
                            <div className={styles.textContainer}>
                                <p className={styles.title}>If this was you</p>
                                <p>
                                    Simply click the button below to add this
                                    device to your list of trusted devices and
                                    log in.
                                </p>
                            </div>

                            <div className={styles.textContainer}>
                                <p className={styles.title}>
                                    If this wasn't you
                                </p>
                                <p>
                                    Please contact us immediately to report this
                                    login and consider changing your password
                                    for security reasons.
                                </p>
                            </div>
                        </div>
                        <div className={styles.buttonRow}>
                            <AmnisButton
                                onClick={handleEnableDevice}
                                isLoading={isPending}
                            >
                                It was me, add this device
                            </AmnisButton>
                            <AmnisButton intent="terciary" onClick={handleDeny}>
                                It wasn't me, change password
                            </AmnisButton>
                        </div>
                    </>
                )}
            </div>
            <PublicPageFooter />
        </div>
    );
};

export default DeviceWhitelistingPublicPage;

const Icon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="57"
        height="56"
        viewBox="0 0 57 56"
        fill="none"
    >
        <mask
            id="mask0_37311_515"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="57"
            height="56"
        >
            <rect x="0.5" width="56" height="56" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_37311_515)">
            <path
                d="M26.7499 39.0833H30.2498V25.6667H26.7499V39.0833ZM28.4999 21.6731C29.0338 21.6731 29.4814 21.4925 29.8426 21.1313C30.2038 20.7701 30.3844 20.3225 30.3844 19.7885C30.3844 19.2546 30.2038 18.807 29.8426 18.4458C29.4814 18.0846 29.0338 17.904 28.4999 17.904C27.9659 17.904 27.5183 18.0846 27.1571 18.4458C26.7959 18.807 26.6153 19.2546 26.6153 19.7885C26.6153 20.3225 26.7959 20.7701 27.1571 21.1313C27.5183 21.4925 27.9659 21.6731 28.4999 21.6731ZM28.5038 50.1666C25.4379 50.1666 22.5562 49.5848 19.8585 48.4213C17.1609 47.2577 14.8143 45.6787 12.8188 43.684C10.8232 41.6894 9.24341 39.3438 8.07934 36.6474C6.91528 33.9509 6.33325 31.0698 6.33325 28.0039C6.33325 24.9381 6.91503 22.0563 8.07859 19.3587C9.24214 16.661 10.8212 14.3144 12.8158 12.3189C14.8105 10.3234 17.1561 8.74356 19.8525 7.5795C22.549 6.41544 25.4301 5.8334 28.496 5.8334C31.5618 5.8334 34.4435 6.41518 37.1412 7.57874C39.8389 8.74229 42.1855 10.3214 44.181 12.316C46.1765 14.3106 47.7563 16.6562 48.9204 19.3527C50.0844 22.0491 50.6665 24.9303 50.6665 27.9961C50.6665 31.062 50.0847 33.9437 48.9211 36.6413C47.7576 39.339 46.1785 41.6856 44.1839 43.6811C42.1892 45.6767 39.8437 47.2565 37.1472 48.4205C34.4508 49.5846 31.5696 50.1666 28.5038 50.1666ZM28.4999 46.6667C33.711 46.6667 38.1249 44.8584 41.7415 41.2417C45.3582 37.625 47.1665 33.2111 47.1665 28C47.1665 22.7889 45.3582 18.375 41.7415 14.7583C38.1249 11.1417 33.711 9.33335 28.4999 9.33335C23.2888 9.33335 18.8749 11.1417 15.2582 14.7583C11.6415 18.375 9.83319 22.7889 9.83319 28C9.83319 33.2111 11.6415 37.625 15.2582 41.2417C18.8749 44.8584 23.2888 46.6667 28.4999 46.6667Z"
                fill="url(#paint0_linear_37311_515)"
            />
        </g>
        <defs>
            <linearGradient
                id="paint0_linear_37311_515"
                x1="50.029"
                y1="5.45016"
                x2="32.3998"
                y2="69.8351"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0.0813806" stop-color="#E45462" />
                <stop offset="0.314027" stop-color="#DF3344" />
                <stop offset="0.754131" stop-color="#99000F" />
            </linearGradient>
        </defs>
    </svg>
);
